module.exports = __webpack_public_path__ + "img/mf.ffa214fb.svg";